export default __webpack_public_path__ + "static/media/mobis.4e3b1bd9.png";